import style from "./expiryDateRow.module.scss";
import classNames from "classnames";
import FolderIcon from "components/icons/folder";
import { Button } from "components/UI/button/button";
import translations from "locales";
import { DateFormat, formatDateToString, parseDateString } from "utils/commonFunctions";
interface IExpiryDateRow {
  docName: string
  type: string
  expiryDate: string
  issueDate: string
  onClick?: () => void;
  onClickButton?: () => void;
  ref?: any;
  showButton?: boolean
  isCompleted?: boolean
}
export const ExpiryDateRow = ({
  docName,
  type,
  expiryDate,
  issueDate,
  ref,
  onClick = () => undefined,
  onClickButton = () => undefined,
  showButton = true,
  isCompleted = false,
}: IExpiryDateRow) => {

  const formattedExpiryDate = expiryDate ? formatDateToString(parseDateString(expiryDate), DateFormat.YYYY_MM_DD_slashes) : 'n/a';
  const formattedIssueDate = issueDate ? formatDateToString(parseDateString(issueDate), DateFormat.YYYY_MM_DD_slashes) : 'n/a';
  const parsedIssueDate = parseDateString(issueDate);
  const parsedExpiryDate = parseDateString(expiryDate);
  const isExpired = parsedExpiryDate && parsedExpiryDate < new Date();  
  const lang = localStorage.getItem('lang') || 'en';

  return (
    <>
      <tr className={style.barRow}>
        <td colSpan={4}/>
      </tr>
      <tr onClick={onClick} className={style.selectableRow} ref={ref}>
        <td>
          <div className={style.companyName}>{docName ? docName : 'n/a'}</div>
        </td>
        <td>
          <div className={style.companyName}><FolderIcon/>{type ? type : 'n/a'}</div>
        </td>
        <td className={style.issueColumn}> 
          <div>
            {formattedIssueDate}
          </div>
        </td>
        <td className={style.expiryColumn}> 
          <div className={classNames({ [style.expired]: isExpired })}>
            {formattedExpiryDate}
          </div>
        </td>
        <td>
          <div className={style.buttonColumn}>
            {isCompleted ? (
              <p className={style.sentRequest}>{lang === 'fr' ? translations.fr.extension_requested : translations.en.extension_requested}</p>
            ) : showButton ? (
              <Button onClick={onClickButton} className={style.iconButton}>+</Button>
            ) : null}
          </div>
        </td>
      </tr>
    </>
  );
};